<template>
    <div id="contentAreaInner">
        <h1 class="page_title">お問い合わせ</h1>
        <vue-loading
            v-if="this.overAllSearching"
            type="spin"
            color="#333"
            :size="{ width: '50px', height: '50px' }"
        ></vue-loading>
        <div v-else>
            <NoticeBox :notice="notice" v-for="(notice, index) in topInfo" :key="index"/>

            <h2 class="sub_title">よくある問い合わせランキング{{ faqRankingData.length }}</h2>
            <div class="qa_box">
                <div v-for="(item, index) in faqRankingData">
                    <QaBoxRanking
                        v-bind:index="index"
                        v-bind:question="item.Question"
                        v-bind:answer="setCfUrl(item.Answer)"
                        v-bind:text="item.LeadText"
                        v-bind:url="item.LinkURL"
                    />
                </div>
            </div>
            <SearchForm :contactData="contactData"/>
        </div>
        <!-- チャット以外のお問い合わせ -->
        <Inquiry-Navi :notice="bottomInfo"/>

        <h2 class="sub_title">関連リンク</h2>
        <relatedLinkList/>

        <div class="upper" v-if="this.upperShow">
            <span class="round_btn" @click="deleteFaqChat()"></span>
            <div @click="clickFaqChat()">
                <div>
                    <img
                        class="akiko-shokai"
                        src="img/akiko_shokai_migi.png"
                        alt="あきこ紹介ポーズ"
                        width="80px"
                    />
                </div>
                <div class="balloon-left">
                    <p>問い合わせは便利な<br/>チャットボットで！</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import {mapState, mapMutations} from "vuex";
import SearchForm from "@/components/SearchForm.vue";
import relatedLinkList from "@/components/relatedLinkList.vue";
import QaBoxRanking from "@/components/QaBoxRanking.vue";
import InquiryNavi from "@/components/InquiryNavi.vue";
import NoticeBox from "@/components/NoticeBox.vue";
import {VueLoading} from "vue-loading-template";
import axios from 'axios'

export default {
    name: "Faq",
    components: {
        SearchForm,
        relatedLinkList,
        QaBoxRanking,
        InquiryNavi,
        NoticeBox,
        VueLoading
    },
    data() {
        return {
            topInfo: [
                {value: '', title: ''},
                {value: '', title: ''}
            ],
            bottomInfo: {
                value: '',
                title: ''
            },
            faqRankingData: [],
            contactData: []
        }
    },
    computed: {
        ...mapState(["upperShow", "overAllSearching"]),
    },
    methods: {
        deleteFaqChat(){
            this.$store.commit('setUpperShow', false);
        },
        async init() {
            this.$store.commit('setOverOllSearching', true);
            const response = await axios.get(process.env.VUE_APP_STATISTICS_URL + '/func_get_notice');
            response.data.forEach(function (element) {
                switch (element.id) {
                    case '上部':
                        this.topInfo[0].value = element.value.replace(/\n/g, "<br />");
                        this.topInfo[0].title = element.title;
                        break;
                    case '上部2':
                        this.topInfo[1].value = element.value.replace(/\n/g, "<br />");
                        this.topInfo[1].title = element.title;
                        break;
                    case '下部':
                        this.bottomInfo.value = element.value.replace(/\n/g, "<br />");
                        this.bottomInfo.title = element.title;
                        break;
                }
                ;
            }, this);

            const faqRankingResponse = await axios.get(process.env.VUE_APP_FUNCTIONS_URL + '/func_get_faq_top5');
            this.faqRankingData = faqRankingResponse.data;

            const contactResponse = await axios.get(process.env.VUE_APP_STATISTICS_URL + '/func_get_faq_group');
            this.contactData = contactResponse.data;
            if((this.contactData.length % 3) === 2){
                this.contactData.push([]);
            }
            this.$store.commit('setOverOllSearching', false);
        },
        clickFaqChat() {
            window.open("https://www.lawson.co.jp/faq/chat/agreement.html", "window1", "width=1000px,height=1000px");
        },
        setCfUrl(path){
            if(path && process.env.VUE_APP_FAQ_CF_URL){
                path = path.replace(process.env.VUE_APP_FAQ_URL, process.env.VUE_APP_FAQ_CF_URL);
            }
            return path;
        },
    },
    mounted() {
        this.init();
    }
};
</script>

<style scoped>
.qa_box {
    text-align: left;
    margin-top: 30px;
}

/* 吹き出し */
.upper {
    display: block;
    position: fixed;
    right: 10px;
    bottom: 10px;
    flex-direction: row;
    background: #fff;
    border-radius: 10px;
    cursor: pointer;
}

.upper div{
    display: flex;
}
@media screen and (max-width: 754px) {
    .upper {
        display: none;
    }
}

.balloon-left {
    position: relative;
    display: inline-block;
    padding: 7px 10px;
    min-width: 120px;
    margin: 10px 0px 0px 20px;
    max-width: 100%;
    color: #555;
    font-size: 12px;
    background: #fff;
    border: solid 3px #555;
    box-sizing: border-box;
    border-radius: 10px;
    height: 60px;
}

.balloon-left:before {
    content: "";
    position: absolute;
    top: 50%;
    left: -47px;
    margin-top: -12px;
    border: 12px solid transparent;
    border-right: 36px solid #fff;
    z-index: 2;
}

.balloon-left:after {
    content: "";
    position: absolute;
    top: 50%;
    left: -59px;
    margin-top: -14px;
    border: 14px solid transparent;
    border-right: 42px solid #555;
    z-index: 1;
}

.balloon-left p {
    margin: 0;
    padding: 0;
}

.round_btn {
    display: block;
    position: absolute;
    width: 30px;
    height: 30px;
    border: 2px solid #555; /* 枠の調整 */
    border-radius: 50%;  /* 丸みの度合い */
    background: #fff; /* ボタンの背景色 */
    top: -15px;
    left: -15px;
}

.round_btn::before, .round_btn::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 3px; /* 棒の幅（太さ） */
    height: 22px; /* 棒の高さ */
    background: #555; /* バツ印の色 */
}

.round_btn::before {
    transform: translate(-50%,-50%) rotate(45deg);
}

.round_btn::after {
    transform: translate(-50%,-50%) rotate(-45deg);
}

</style>
